import script from "./NotificationDetailPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationDetailPopup.vue?vue&type=script&setup=true&lang=ts"

import "./NotificationDetailPopup.vue?vue&type=style&index=0&id=dc570c5a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\digi_aj\\source\\repos\\1ANAB_Vue_Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc570c5a"]])

export default __exports__